export class Event {
  id: number;
  data: any;

  constructor(id, data?) {
    this.id = id;
    this.data = data;
  }
}
